$(document).ready(function () {
  if ($('.variant-wrapper').length > 0) {
    handleInitialLoad();

    $(document).on("click", ".ajax-cart-submit-button", handleAjaxCartButtonClick);

    $(document).on("change", ".variant-wrapper--dropdown select", handleDropdownChange);

    $(document).on("click", ".variant-wrapper .variant-input-wrap .variant-input", handleDropdownChange);
    
    
  }
   $(document).on('click', '.error-message', function() {
      $('.error-message').removeClass('show_notice');
    });
});

function handleInitialLoad() {
  if (window.location.href.indexOf('variant=') === -1)  {
    setInitialButtonStates();
    selectFirstOptions();
  }
}

function setInitialButtonStates() {
  $('.product-add-to-cart-submit-button').hide();
  $('.payment-buttons .shiprocket-headless').addClass('disabled');
  $('.ajax-cart-submit-button').show();
}

function selectFirstOptions() {
  $('.variant-wrapper--dropdown select').each(function() {
    $(this).find('option').eq(0).prop('selected', true);
  });
}

function handleAjaxCartButtonClick() {
  let isFirstOptionSelected = false;
  $('.variant-wrapper--dropdown select').each(function() {
    if ($(this).find('option').eq(0).is(':selected')) {
      isFirstOptionSelected = true;
    }
  });
  if(!$('.variant-input input:checked').length){
        isFirstOptionSelected = true;
    }
  
  if (isFirstOptionSelected) {
    $('.error-message').addClass('show_notice');
  }
}


function handleDropdownChange() {
  $('.payment-buttons .shiprocket-headless').removeClass('disabled');
  $('.error-message').removeClass('show_notice');
  $('.ajax-cart-submit-button').hide();
  $('.product-add-to-cart-submit-button').show();
}
